module.exports = __webpack_public_path__ + "static/media/tik-tok.ac6beaaa.svg";